import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectManufacturerPriorityFilter,
  selectManufacturerPriorityLabelKey,
} from "../../redux/selector";
import { manufacturerActions } from "../../redux/slice";
import { ManufacturerPriorityFilter } from "../../types";
import { useStyles } from "./style";

type Props = {
  onAddClick?: () => void;
};

const PRIORITY_OPTIONS: ManufacturerPriorityFilter[] = [
  "ALL",
  "HIGH",
  "MEDIUM",
  "NORMAL",
];

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const priorityFilter = useSelector(selectManufacturerPriorityFilter);

  const getPriorityLabel = (value: ManufacturerPriorityFilter) => {
    if (value === "ALL") {
      return t("MANUFACTURERS.PRIORITY_FILTER.ALL");
    }

    return t(selectManufacturerPriorityLabelKey(value));
  };

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("MANUFACTURERS.ACTIONS.ADD_MANUFACTURER")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <FilterSelect
        label={t("MANUFACTURERS.PRIORITY_FILTER.LABEL")}
        value={priorityFilter}
        options={PRIORITY_OPTIONS}
        getOptionLabel={getPriorityLabel}
        onChange={(value) =>
          dispatch(manufacturerActions.setManufacturerPriorityFilter(value))
        }
      />
    </div>
  );
};

export default ActionBar;
